module.exports = __webpack_public_path__ + "static/better-employee-02-1080w-876b859a2a942518e112027962f5541b.jpg";